const CDN_BASE = 'https://aipeces-media-a4hsbvf5gff3b6b0.z02.azurefd.net';

export const PUBLIC_SITE_BASE = 'https://www.aipeces.com';
export const PUBLIC_BLOG_BASE = `${PUBLIC_SITE_BASE}/blog`;

export function resolveBlogImageUrl(url: string | null | undefined): string {
    const trimmed = String(url || '').trim();
    if (!trimmed) return '';
    if (/^https?:\/\//i.test(trimmed)) return trimmed;
    return `${CDN_BASE}/${trimmed.replace(/^\//, '')}`;
}

/** Path relativo público: /blog/<slug> (ES) o /en/<slug> (EN). */
export function publicBlogPath(slug: string, locale: 'es' | 'en' = 'es'): string {
    const s = encodeURIComponent(String(slug || '').trim());
    return locale === 'en' ? `/en/${s}` : `/blog/${s}`;
}

export function publicBlogUrl(slug: string, locale: 'es' | 'en' = 'es'): string {
    return `${PUBLIC_SITE_BASE}${publicBlogPath(slug, locale)}`;
}

/** Reescribe src relativos del cuerpo para la vista previa. */
export function rewritePreviewMedia(html: string): string {
    return String(html || '').replace(
        /\b(src|href)=["'](?!https?:|data:|mailto:|#|\/)([^"']+)["']/gi,
        (_m, attr: string, path: string) => `${attr}="${resolveBlogImageUrl(path)}"`,
    );
}
